//import logo from "../../assets/img/logo.svg";
import pickPackLogo from "../../assets/img/pp-light-2.png";
import "./style.less";

const Logo = () => {
  return (
    <div className="logo-container">
      <a href="/merchant/order/delivery">
        <img className="logo-image" src={pickPackLogo} alt="logo" />
      </a>
    </div>
  );
};

export default Logo;
